import React, { Component, Fragment } from 'react';
import Dialog from '@mui/material/Dialog';
import SpatialReference from '@arcgis/core/geometry/SpatialReference';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import CloseIcon from '@mui/icons-material/Close';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton'
import Grid from '@mui/material/Grid';
import SpatialFilterMap from './SpatialFilterMap';
import SpatialFilterList from './SpatialFilterList';
import TextField from '@mui/material/TextField';
import { Snackbar, Alert } from "@mui/material";

export class SpatialFilterLibraryDialog extends Component {
    constructor(props) {
        super(props);

        this.state =
        {
            selectedFilter: null,
            selectedGeometry: null,
            isUploading: false,
            filterSelected: false,
            showNameDialog: false,
            filterName: '',
            errorOpen: false
        };
    }

    setSelectedFilter = (filter) => {

        this.setState({
            selectedFilter: filter,
            selectedGeometry: filter.geometry,
            filterName: filter.attributes.Filtername,
            filterSelected: true
        });
    }

    setSelectedGeometry = (geometry) => {

        this.setState({
            selectedGeometry: geometry,
            filterSelected: true
        });
    }

    handleNameOkay = () => {
        let updatedFilter = Object.assign({}, this.state.selectedFilter);
        updatedFilter.attributes.Filtername = this.state.filterName;

        window.api.updateSpatialFilterName(updatedFilter).then(response => {
            this.props.setSpatialFilters(response);
        });

        this.setState({
            selectedFilter: updatedFilter,
            showNameDialog: false,
            filterName: ''
        });

    }

    handleNameClose = () => {
        this.setState({
            showNameDialog: false
        });
    }

    onNameChange = (value) => {
        this.setState({
            filterName: value
        });
    }

    uploadShapefile = (event) => {
        event.preventDefault();
        let input = this.refs.input_reader;
        input.click();
    }

    inputFileChanged = async (e) => {
        if (window.FileReader) {
            this.setState({
                isUploading: true
            });
        }

        let file = e.target.files && e.target.files.length > 0 ? e.target.files[0] : null;
        this.generateFeatureCollection(file);
        this.refs.input_reader.value = null;
    }

    useSelectedFilter = () => {
        //this.state.selectedFilter

        this.props.onFilterSelected(this.state.selectedFilter);
    }

    generateFeatureCollection = (file) => {
              var params = {
                  name: file,
                  targetSR: new SpatialReference(4269),
                  maxRecordCount: 1000,
                  enforceInputFileSizeLimit: true,
                  enforceOutputJsonSizeLimit: true
              };

              // generalize features to 10 meters for better performance
              //TODO: These are being overwritten by the API call
              params.generalize = true;
              params.maxAllowableOffset = 5;
              params.reducePrecision = false;
              //params.numberOfDigitsAfterDecimal = 3;

              window.api.addFilterFromShapefile(params, file, "", "").then(spatialFilter => {
                  if (spatialFilter) 
                      {
                          this.setSelectedFilter(spatialFilter);
                          this.setState({
                              showNameDialog: true
                          });
                  }
              }
              ).catch(err => {
                  this.setState({ showShapeParseError: true, errorOpen: true });
              });
    }

    render() {

        return (

            <Fragment>
                <Dialog
                title="Spatial Filter Library"
                PaperProps={{
                    sx: {
                        minHeight: '600px',
                        minWidth: '50%',
                        maxWidth: '50%'
                    }
                }}
                open={this.props.open}>
                <AppBar position="relative">
                    <Toolbar variant="dense">
                        <Typography variant="h6" color="inherit">
                            Spatial Filter Library
                        </Typography>
                        <IconButton color="inherit" onClick={this.props.onClose} style={{ position: "relative", float: "right", marginLeft: "auto" }} aria-label="close">
                            <CloseIcon />
                        </IconButton>
                    </Toolbar>
                </AppBar>
                <DialogContent>
                    <input type="file" ref="input_reader" accept=".zip" multiple={false} style={{ display: 'none' }} onChange={this.inputFileChanged} />
                    <Grid container style={{minHeight: "550px"}}>
                        <Grid item xs={3}>
                            <SpatialFilterList setSpatialFilters={this.props.setSpatialFilters} spatialFilters={this.props.spatialFilters} onSpatialFilterClicked={this.setSelectedFilter} />
                        </Grid>
                        <Grid item xs={9}>
                            <SpatialFilterMap
                                open={this.props.open}
                                selectedGeometry={this.state.selectedGeometry}
                            />
                        </Grid>
                    </Grid>
                  <Snackbar
                        open={this.state.errorOpen}
                        autoHideDuration={4000}
                        onClose={() => this.setState({ errorOpen: false }) }
                        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}>
                        <Alert severity="error" onClose={() =>  this.setState({ errorOpen: false }) }>
                        Failed to add filter from shapefile, please confirm the validity and complexity of the geometry.
                        </Alert>
                    </Snackbar>
                </DialogContent>
                <DialogActions>
                    <Button color="primary" disabled={!this.state.filterSelected} onClick={this.useSelectedFilter}>
                        Use Selected Filter
                    </Button>
                    <Button onClick={this.uploadShapefile}>
                        Upload New Shapefile
                    </Button>
                    <Button onClick={this.props.onClose}>
                        Close
                    </Button>
                </DialogActions>
            </Dialog>
            <Dialog
            open={this.state.showNameDialog}
            onClose={this.handleNameClose}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description">
            <DialogTitle id="alert-dialog-title">
            {"Provide a filter name"}
            </DialogTitle>
            <DialogContent>
            <TextField defaultValue={this.state.filterName} onChange={(event) => { this.onNameChange(event.target.value); }} />
            </DialogContent>
            <DialogActions>
                <Button onClick={this.handleNameOkay} autoFocus>OK</Button>
            </DialogActions>
        </Dialog>
        </Fragment>
        )
    }
}

export default SpatialFilterLibraryDialog;
